import { render, staticRenderFns } from "./SettingsForm.vue?vue&type=template&id=083378b2&scoped=true&"
import script from "./SettingsForm.vue?vue&type=script&lang=js&"
export * from "./SettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083378b2",
  null
  
)

export default component.exports